export default __webpack_public_path__ + "static/media/illustration-algowork-w.8d36b0dc.webp";